



let host = location.origin

let baseUrl_ = "https://gw.mangolive.in"
if (/uangzh/.test(host)) {
    baseUrl_ = 'https://mango-api.guangzhoumaitian.com'
}

export const baseUrl = baseUrl_

// export const  baseUrl="/api"


// WEBPACK FOOTER //
// ./src/api/config.js